// extracted by mini-css-extract-plugin
export default {"container":"tFLYCI mz-interactive-info-block--white","loading":"A8IWCe"};